// WidgetSubirArchivo.jsx
import React, { useState, useEffect, useId } from "react";

const WidgetSubirArchivo = (props) => {
    const [selectedFile, setSelectedFile] = useState("");
    const inputId = useId(); // Genera un ID único

    // Si se pasa un indicador en payload (por ejemplo, fileType) y cambia, reiniciamos el estado
    useEffect(() => {
        setSelectedFile("");
    }, [props.payload?.fileType]);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file.name);
            // Simulamos la subida enviando el nombre del archivo
            props.actionProvider.manejarFlujoVenta(file.name);
        }
    };

    return (
        <div className="widget-subir-archivo">
            <input type="file" id={inputId} onChange={handleFileChange} />
            <label htmlFor={inputId}>Selecciona un archivo</label>
            {selectedFile && <div className="file-name">{selectedFile}</div>}
        </div>
    );
};

export default WidgetSubirArchivo;
